var PaymentCtrl = require('../../payment/controllers/payment'); // Шлях до PaymentCtrl

angular.module('pages.service')
	.controller('ServiceCtrl', ServiceCtrl);

ServiceCtrl.$inject = ['$scope', '$controller', '$rootScope', 'ClientCards'];

function ServiceCtrl($scope, $controller, $rootScope, ClientCards) {
	angular.extend(this, $controller(PaymentCtrl, { $scope: $scope }));

	$scope.vibrateBlock = false;
	$scope.amountValue = null;

	$rootScope.hideHeader = true;
	$rootScope.showCardBlock = false;

	$scope.validateAmount = function () {
		if($scope.amountValue > 29999) {
			$scope.amountValue = 29999;
		}
		$scope.pay.amountInput = $scope.amountValue;

		$scope.updateInputWidth();
	}

	$scope.addAmount = function (value) {
		const parsedAmount = parseFloat($scope.pay.amountInput) || 0;

		$scope.pay.amountInput = $scope.amountValue = parsedAmount + value;
		$scope.validateAmount();

		setTimeout(function () {
			$scope.updateInputWidth();
		}, 100);
	}

	$scope.updateInputWidth = function() {
		var input = document.querySelector('#amount-input');
		input.style.width = ((input.value.length + 1) * 20) + 'px';
	};

	$scope.openCardBlock = function () {
		if($scope.pay.amountInput) {
			$scope.showCardBlock = true;
			setTimeout(function () {
				var cardA1Element = document.getElementById('cardA1');
				if (cardA1Element) {
					cardA1Element.focus();
				}
			},600);
		} else {
			$scope.vibrateBlockFn();
		}
	}

	$scope.donate = function () {
		if(!$scope.confirmFrom.$valid) {
			return false;
		}

		if (!$scope.amountValue) {
			$scope.vibrateBlockFn();
		} else {
			$scope.pay.confirmServicePayment()
		}
	}

	$scope.vibrateBlockFn = function () {
		if (!$scope.vibrateBlock) {
			$scope.vibrateBlock = true;

			setTimeout(function () {
				$scope.vibrateBlock = false;
				$scope.$apply();
			}, 600);
		}
	}
}

module.exports = ServiceCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/service/controllers/service.controller.js
 ** module id = 288
 ** module chunks = 1
 **/